/**
 * Beta status set. Flat by design — no subtasks, no per-project workflows.
 */
export const TASK_STATUSES = [
    "Not Started",
    "In Progress",
    "Blocked",
    "Done",
];
/**
 * Is this task or deliverable a request still waiting for a PM (punch list
 * F140)? Requested, not approved and not cancelled -- a rejected request is
 * cancelled, and reads as cancelled.
 */
export function isPendingRequest(item) {
    return item.requestedAt !== null && item.approvedAt === null && item.cancelledAt === null;
}
/**
 * Does this task keep its project or deliverable from being marked complete?
 *
 * **The page's copy of the server's rule, kept word for word.** The server
 * counts `t.status <> 'Done' AND t.cancelled_at IS NULL AND t.hibernated_at
 * IS NULL` in `setProjectCompleted` and `setDeliverableCompleted`; the
 * project and deliverable pages offer "Mark ... complete" only when no task
 * passes this. Until 23 Oct 2026 the pages left hibernated work out of the
 * rule (and the task data did not carry it), so a project whose only open
 * work was hibernated never offered the button the server would have
 * honoured. `api/test/hibernation.test.ts` asserts the two agree.
 */
export function holdsContainerOpen(task) {
    return task.status !== "Done" && task.cancelledAt === null && task.hibernatedAt === null;
}
//# sourceMappingURL=task.js.map